import React from 'react';

interface WarningProps {
  className?: string;
  width?: number;
  height?: number;
}

const WarningIcon = function WarningIcon({
  className,
  width,
  height,
}: WarningProps): JSX.Element {
  return (
    <div style={{ textAlign: 'center' }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        width={width}
        height={height}
        viewBox="0 0 62 62"
      >
        <g id="Info_fill">
          <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M7.75 31C7.75 18.1594 18.1594 7.75 31 7.75C43.8406 7.75 54.25 18.1594 54.25 31C54.25 43.8406 43.8406 54.25 31 54.25C18.1594 54.25 7.75 43.8406 7.75 31ZM28.4167 41.3333C28.4167 39.9066 29.5733 38.75 31 38.75C32.4267 38.75 33.5833 39.9066 33.5833 41.3333C33.5833 42.7601 32.4267 43.9167 31 43.9167C29.5733 43.9167 28.4167 42.7601 28.4167 41.3333ZM30 18.0833V33.5833H32V18.0833H30Z" fill="#F9C371" />
        </g>
      </svg>
    </div>
  );
};

WarningIcon.defaultProps = {
  className: '',
  width: 62,
  height: 62,
};

export default WarningIcon;
